import { render, staticRenderFns } from "./Monitor.vue?vue&type=template&id=2dcff70f&scoped=true"
import script from "./Monitor.vue?vue&type=script&lang=js"
export * from "./Monitor.vue?vue&type=script&lang=js"
import style0 from "./Monitor.vue?vue&type=style&index=0&id=2dcff70f&prod&scoped=true&lang=css"
import style1 from "./Monitor.vue?vue&type=style&index=1&id=2dcff70f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcff70f",
  null
  
)

export default component.exports